<div class="space-y-6">
  <h2 class="mb-6 text-center text-3xl font-bold text-greyscale-900">
    {{ "register.setupYourCompany" | transloco }}
  </h2>

  <form [formGroup]="companyForm" (ngSubmit)="onSubmit()" class="space-y-6">
    <!-- Company Name -->
    <div>
      <label
        for="companyName"
        class="mb-1 block text-sm font-medium text-greyscale-700"
        >{{ "register.companyName" | transloco }}</label
      >
      <input
        id="companyName"
        type="text"
        formControlName="companyName"
        [placeholder]="'register.enterCompanyName' | transloco"
        class="w-full rounded-md border border-greyscale-300 px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500"
        [class.border-error-500]="
          companyForm.get('companyName')?.invalid &&
          companyForm.get('companyName')?.touched
        "
      />

      <!-- Validation messages -->
      @if (
        companyForm.get("companyName")?.errors &&
        companyForm.get("companyName")?.touched
      ) {
        <div class="mt-1">
          <small class="text-error-600">{{
            "register.companyNameRequired" | transloco
          }}</small>
        </div>
      }

      @if (isCheckingCompanyName) {
        <div class="mt-1">
          <small class="text-primary-600">
            <i class="pi pi-spinner pi-spin mr-1"></i>
            {{ "register.checkingCompanyName" | transloco }}
          </small>
        </div>
      }
    </div>

    <!-- Company Name Conflict Dialog -->
    @if (showConflictDialog) {
      <div class="rounded-md border border-warning-300 bg-warning-50 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <i class="pi pi-exclamation-triangle text-warning-500"></i>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-warning-800">
              {{ "register.similarCompanyFound" | transloco }}
            </h3>
            <div class="mt-2 text-sm text-warning-700">
              <p>
                {{ "register.similarCompanyExistsMessage" | transloco }}
                <strong>"{{ getSimilarCompanyName() }}"</strong>
              </p>
            </div>

            <div class="mt-4">
              <button
                type="button"
                (click)="joinSimilarCompany()"
                class="rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                <i class="pi pi-user-plus mr-2"></i>
                {{ "register.requestAccessToCompany" | transloco }} "{{
                  getSimilarCompanyName()
                }}"
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Other Company Fields (hidden during conflict) -->
    @if (!showConflictDialog) {
      <div class="space-y-4">
        <!-- Country -->
        <div>
          <label
            for="country"
            class="mb-1 block text-sm font-medium text-greyscale-700"
            >{{ "register.country" | transloco }}</label
          >
          <p-select
            inputId="country"
            formControlName="country"
            [options]="countryOptions"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'register.selectCountry' | transloco"
            styleClass="w-full"
            panelStyleClass="w-full"
          ></p-select>
        </div>

        <!-- Type of organisation -->
        <div>
          <label
            for="organisationType"
            class="mb-1 block text-sm font-medium text-greyscale-700"
            >{{ "register.organisationType" | transloco }}</label
          >
          <p-select
            inputId="organisationType"
            formControlName="organisationType"
            [options]="organisationTypeOptions"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'register.selectOrganisationType' | transloco"
            styleClass="w-full"
            panelStyleClass="w-full"
          ></p-select>
        </div>

        <!-- Company Size -->

        <div>
          <label
            for="size"
            class="mb-1 block text-sm font-medium text-greyscale-700"
          >
            {{ "accountMenu.billingInformation.companySize" | transloco }}
          </label>
          <p-select
            id="size"
            formControlName="size"
            [placeholder]="
              'accountMenu.billingInformation.placeholder.companySize'
                | transloco
            "
            [options]="sizeOptions"
            class="w-full"
          />
        </div>

        <!-- Your role -->
        <div>
          <label
            for="userRole"
            class="mb-1 block text-sm font-medium text-greyscale-700"
            >{{ "register.yourRoleInCompany" | transloco }}</label
          >
          <input
            id="userRole"
            type="text"
            formControlName="userRole"
            [placeholder]="'register.roleExamplePlaceholder' | transloco"
            class="w-full rounded-md border border-greyscale-300 px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500"
            [class.border-error-500]="
              companyForm.get('userRole')?.invalid &&
              companyForm.get('userRole')?.touched
            "
          />
          @if (
            companyForm.get("userRole")?.errors &&
            companyForm.get("userRole")?.touched
          ) {
            <div class="mt-1">
              <small class="text-error-600">{{
                "register.pleaseEnterRole" | transloco
              }}</small>
            </div>
          }
        </div>

        <!-- Promo Code - Hidden for now -->
        <!-- 
      <div>
        <label class="mb-1 block text-sm font-medium text-greyscale-700">
          {{ 'register.promoCode' | transloco }} <span class="text-greyscale-500">({{ 'register.optional' | transloco }})</span>
        </label>
        <input
          type="text"
          formControlName="promoCode"
          [placeholder]="'register.enterPromoCode' | transloco"
          class="w-full rounded-md border border-greyscale-300 px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500"
        />
      </div>
      -->

        <!-- Invite Colleagues - Hidden for now -->
        <!-- 
      <div>
        <label class="mb-1 block text-sm font-medium text-greyscale-700">
          {{ 'register.inviteColleagues' | transloco }}
          <span class="text-greyscale-500">({{ 'register.optional' | transloco }})</span>
        </label>
        <textarea
          formControlName="inviteEmails"
          placeholder="colleague1@company.com,&#10;colleague2@company.com"
          rows="3"
          class="w-full resize-none rounded-md border border-greyscale-300 px-3 py-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary-500"
        ></textarea>
        <small class="mt-1 block text-xs text-greyscale-500"
          >{{ 'register.separateEmails' | transloco }}</small
        >
      </div>
      --></div>

      <!-- Submit Button -->
      <div class="pt-6">
        <button
          type="submit"
          [disabled]="isLoading || showConflictDialog"
          class="flex w-full items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        >
          @if (isLoading) {
            <i class="pi pi-spinner pi-spin mr-2"></i>
          } @else {
            <i class="pi pi-building mr-2"></i>
          }
          {{
            isLoading
              ? ("register.creatingAccount" | transloco)
              : ("register.createCompany" | transloco)
          }}
        </button>
      </div>
    }
  </form>
</div>
